import { ActionsDispatcher } from 'store/ActionsDispatcher';
import { WidgetCustomManagedStreamOptions } from 'widgets/streaming/widgetStreamManager/WidgetCustomStreamManager';
import {
    createClearStreamDataAction,
    createRemoveStreamDataAction,
} from 'streamsState/store/streamedData/actions';
import { StreamError } from 'streamsState/store/streamStatuses/StreamErrorState';
import IndigoApi from 'communication/IndigoApi';
import RequestProgressService from 'requestProgress/RequestProgressService';
import { WidgetRequestResponseByUidManagerBase } from 'widgets/streaming/widgetStreamManager/RequestResponse/WidgetRequestResponseByUidManagerBase';
import { StreamDataHandlers } from 'streamsState/StreamDataService';
import { ChannelDestination } from 'communication/Channel';
import { buildByStreamKeyHandlers } from 'streamsState/store/streamedData/handlers';

export class WidgetRequestResponseByUidRpcManager extends WidgetRequestResponseByUidManagerBase {
    private indigoApi: IndigoApi;
    private requestProgressService: RequestProgressService;
    private readonly messageHandlers: StreamDataHandlers<unknown>;
    private readonly channelDestination: ChannelDestination;

    public constructor(options: WidgetCustomManagedStreamOptions) {
        super(
            'WidgetStreamByRequestUidRpcStreamManager-' +
                options.channelDestination,
            options.channelDestination,
            options
        );

        this.indigoApi = options.indigoApi;
        this.requestProgressService = options.requestProgressService;
        this.channelDestination = options.channelDestination;
        this.messageHandlers = buildByStreamKeyHandlers(
            options.store,
            options.channelDestination
        );
    }

    protected callApi(
        dispatcher: ActionsDispatcher,
        payload: unknown
    ): Promise<unknown> {
        const apiCall = () =>
            this.indigoApi.rpcRequest(payload, this.channelDestination);

        return this.requestProgressService.invokeAndMonitorRequest(
            this.channelDestination,
            apiCall
        );
    }

    protected clearRequestData(dispatcher: ActionsDispatcher, key: string) {
        dispatcher.dispatch(
            createClearStreamDataAction(this.channelDestination, key)
        );
    }
    protected handleMessage(
        _dispatcher: ActionsDispatcher,
        key: string,
        request: unknown,
        response: unknown
    ) {
        this.messageHandlers.onMessage(key, response);
    }
    protected handleError(
        _dispatcher: ActionsDispatcher,
        key: string,
        request: unknown,
        error: unknown
    ) {
        this.messageHandlers.onError(key, error as StreamError);
    }
    protected removeRequestData(dispatcher: ActionsDispatcher, key: string) {
        dispatcher.dispatch(
            createRemoveStreamDataAction(this.channelDestination, key)
        );
    }

    public getInfo() {
        return {
            ...super.getInfo(),
            channelDestination: this.channelDestination,
        };
    }
}
